// 是否是邮箱
export const isEmail = val => {
  let reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  return reg.test(val)
}
// 是否是手机号
export const isPhone = val => {
  return /^1[0-9]{10}$/.test(val)
}
// 是否是数字
export const isNum = val => {
  return /^[0-9]*$/.test(val)
}
// 验证是否是邮箱
export const validateEmail = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (!isEmail(value)) {
      callback(new Error('Please enter the correct email format'))
    } else {
      callback()
    }
  }
}
// 验证是否是手机号
export const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (!isPhone(value)) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }
}
// 验证是否是数字
export const validateNumber = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (!isNum(value)) {
      callback(new Error('Please fill out positive integer'))
    } else {
      callback()
    }
  }
}
// 验证数字大小
export const validateNumberSize = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    console.log(rule.maxNum)
    let min = rule.minNum || 0
    let max = rule.maxNum || 0
    let message = rule.message
    if (min && max && (value < min || value > max)) {
      return callback(new Error(message || `请输入范围${min}-${max}`))
    }
    if (min && value < min) {
      return callback(new Error(message || `最小值为${min}`))
    }
    if (max && value > max) {
      return callback(new Error(message || `最大值为${min}`))
    }
    callback()
  }
}
